import { Component, OnInit } from '@angular/core';
import { CategoryService } from 'src/app/services/category.service';
import { Course } from 'src/app/models/course';
import { Category } from 'src/app/models/category';
import { Stream } from 'src/app/models/stream';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';
import { forkJoin } from 'rxjs';
import { FilterService } from 'src/app/services/filter.service';
import { FilterStreamService } from 'src/app/services/filterStream.service';
import { RoleFilters } from 'src/app/models/roleFilters';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss']
})
export class CategoryComponent implements OnInit {
  public loadingCourses=true;
  public courses: Course[];
  public streams: any[];
  public category: Category;
  private category_id:number;
  public streamSlideConfig = {
    "slidesToShow": 4,
    "slidesToScroll": 4,
    'arrows': true,
    autoplay: false,
    'responsive': [
      {'breakpoint': 992, 'settings': { 'slidesToShow': 3, 'slidesToScroll': 3} },
      {'breakpoint': 768, 'settings': { 'slidesToShow': 2, 'slidesToScroll': 2} },
      {'breakpoint': 576, 'settings': { 'slidesToShow': 1, 'slidesToScroll': 1} },
    ]};
  public roleFilters: RoleFilters;
  public breadcrumbLinks=[{routerLink:'/categories', label: 'categories'}];
  public thisPage:string='';
  public image:string='';
  public title:string='';
  public blurb:string='';
  public limited:boolean=false;
  public categoryImagePath:string;

  constructor(
    private categoryService: CategoryService,
    private route: ActivatedRoute,
    private _filterCourse: FilterService,
    private _filterStream: FilterStreamService
  ) {
    this.categoryImagePath=environment.apiEndpoint+'/storage/categories/';
    if(localStorage.getItem('limitedPractice') && localStorage.getItem('limitedPractice') == '1') this.limited=true;
    this.route.params.subscribe(params => {
      this.category_id = params['id'];
    });

    this._filterCourse.roleFiltersSubject.subscribe(
      (data:RoleFilters) => {
        this.roleFilters=data;
        this.categoryService.getCategoryCourses(this.category_id, this.roleFilters, false, true).subscribe(
          data => {
            this.courses=data;
            this.fixCourses();
          }
        );
      }
    );

    this._filterStream.roleFiltersSubject.subscribe(
      (data:RoleFilters) => {
        this.roleFilters=data;
        this.categoryService.getCategoryStreams(this.category_id, this.roleFilters).subscribe(
          data => {
            this.streams=data;
            this.streamCPD();
          }
        );
      }
    );

  }

  fixCourses(){
    let test=[];
    this.courses.forEach((c:any,index)=>{
      if(test[c.course_id]) {
        this.courses.splice(index, 1);
      } else {
        test[c.course_id]=c.course_id;
      }
    });
  }

  streamCPD(){
    this.streams.forEach((stream, index) => {
      this.streams[index].stream.minutes=0;
      stream.stream.active_courses.forEach(course => {
        this.streams[index].stream.minutes+=course.course.points;
      });
    });
  }

  ngOnInit() {
    forkJoin(
      this.categoryService.getCategory(this.category_id),
      // this.categoryService.getCategoryCourses(this.category_id, this.roleFilters),
      this.categoryService.getCategoryStreams(this.category_id, this.roleFilters),
    ).subscribe(data=>{
      // this.courses = data[1];
      this.category = data[0];
      this.streams = data[1];
      this.loadingCourses=false;
      this.streamCPD();
      this.thisPage=this.title=this.category.name;
      if (this.category.media2) {
        if(this.category.media2.url=='/assets/imgs/default-icon.png') this.category.media2.url='default-icon.png';
        this.image=this.categoryImagePath+this.category.media2.url;
      } else {
        if(this.category.media.url=='/assets/imgs/default-icon.png') this.category.media.url='default-icon.png';
        this.image=this.categoryImagePath+this.category.media.url;
      }
    })
  }

}